<template>
  <div id="groupsTechinicalsSpecificationsAdmin">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item active">
        <router-link :to="url">{{ groups }}</router-link>
      </li>
    </ol>
    <div class="container-fluid">
      <div class="card">
        <div class="tab-content noborder">
          <div
            class="tab-pane nopadding active"
            id="tabGroupsTechinicalsSpecificationsAdminTable"
            role="tabpanel"
          >
            <div class="card-body card-body-table">
              <div class="row">
                <div class="col-sm-8">
                  <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item">
                      <button
                        id="tabGroup"
                        class="nav-link active"
                        type="button"
                        data-toggle="tab"
                        href="#tabGroupBody"
                        role="tab"
                        aria-controls="tabGroupBody"
                        v-on:click="onGroupTab"
                      >
                        <i class="fa fa-object-group"></i>
                        <span>{{ groups }}</span>
                      </button>
                    </li>
                    <li class="nav-item">
                      <button
                        id="tabTechnicalSpecification"
                        type="button"
                        class="nav-link"
                        data-toggle="tab"
                        href="#tabTechnicalSpecificationBody"
                        role="tab"
                        aria-controls="tabTechnicalSpecificationBody"
                        :disabled="disableTab"
                        v-on:click="onTechnicalSpecificationTab"
                      >
                        <i class="fa fa-bars"></i>
                        <span>{{ technicalSpecification }}</span>
                      </button>
                    </li>
                    <li class="nav-item">
                      <button
                        id="tabItem"
                        type="button"
                        class="nav-link"
                        data-toggle="tab"
                        href="#tabItemBody"
                        role="tab"
                        aria-controls="tabItemBody"
                        :disabled="disableTab"
                        v-on:click="onItemTab"
                      >
                        <i class="fa fa-cubes"></i>
                        <span>{{ items }}</span>
                      </button>
                    </li>
                  </ul>
                </div>
                <div class="col-sm-4 text-right">
                  <span v-if="spanRowSelected != ''"
                    >{{ group }}: <b>{{ spanRowSelected }}</b></span
                  >
                </div>
              </div>
              <div class="tab-content">
                <div class="tab-pane active" id="tabGroupBody" role="tabpanel">
                  <div class="row">
                    <div class="col-lg-6">
                      <button
                        id="btnAdd"
                        type="button"
                        class="btn btn-sm btn-primary"
                        @click="addGroupTechinicalsSpecifications"
                      >
                        <i class="fa fa-plus"></i>
                        <span>{{ add }}</span>
                      </button>
                      <button
                        id="btnSave"
                        type="button"
                        class="btn btn-sm btn-success"
                        @click="confirmSaveGroupTechinicalsSpecifications"
                        :disabled="disableButton"
                      >
                        <i class="fa fa-floppy-o"></i>
                        <span>{{ save }}</span>
                      </button>
                      <button
                        id="btnDelete"
                        type="button"
                        class="btn btn-sm btn-danger"
                        @click="confirmDeleteGroupTechinicalsSpecifications"
                        :disabled="disableButton"
                      >
                        <i class="fa fa-trash"></i>
                        <span>{{ del }}</span>
                      </button>
                      <button
                        id="btnDuplicate"
                        type="button"
                        class="btn btn-sm btn-warning"
                        @click="confirmDuplicateGroupTechinicalsSpecifications"
                        :disabled="disableTab"
                      >
                        <i class="fa fa-clone"></i>
                        <span>{{ duplicate }}</span>
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <bootstrapTable
                        :configurations="tableConfigurations"
                        :datas="tableData"
                        id="tableGroupsTechinicalsSpecificationsAdmin"
                        :onCheck="onTableCheck"
                        :onCheckAll="onTableCheck"
                        :onUncheck="onTableCheck"
                        :onUncheckAll="onTableCheck"
                        ref="tableGroupsTechinicalsSpecificationsAdmin"
                        :results="tableResult"
                      ></bootstrapTable>
                    </div>
                  </div>
                </div>
                <div
                  class="tab-pane"
                  id="tabTechnicalSpecificationBody"
                  role="tabpanel"
                >
                  <div class="row">
                    <div class="col-sm-5">
                      <bootstrapTable
                        :configurations="
                          tableTechnicalSpecificationIncludedConfiguration
                        "
                        :datas="tableTechnicalSpecificationIncludedData"
                        id="tableTechnicalsSpecificationsIncluded"
                        :onCheck="onTableIncludedCheck"
                        :onCheckAll="onTableIncludedCheck"
                        :onUncheck="onTableIncludedCheck"
                        :onUncheckAll="onTableIncludedCheck"
                        ref="tableTechnicalsSpecificationsIncluded"
                        :results="tableTechnicalSpecificationIncludedResult"
                      ></bootstrapTable>
                    </div>
                    <div class="col-sm-2 vertical-center">
                      <div class="container-fluid">
                        <div class="row">
                          <button
                            type="button"
                            class="btn btn-block btn-primary"
                            @click="addTechnicalSpecification"
                            :disabled="disableAddTechnicalSpecificationButton"
                          >
                            <i class="fa fa-arrow-left"></i>
                            <span>{{ add }}</span>
                          </button>
                        </div>
                        <div class="row">&nbsp;</div>
                        <div class="row">
                          <button
                            type="button"
                            class="btn btn-block btn-secondary"
                            @click="removeTechnicalSpecification"
                            :disabled="
                              disableRemoveTechnicalSpecificationButton
                            "
                          >
                            <i class="fa fa-arrow-right"></i>
                            <span>{{ remove }}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-5">
                      <bootstrapTable
                        :configurations="
                          tableTechnicalSpecificationExcludedConfiguration
                        "
                        :datas="tableTechnicalSpecificationExcludedData"
                        id="tableTechnicalsSpecificationsExcluded"
                        :onCheck="onTableExcludedCheck"
                        :onCheckAll="onTableExcludedCheck"
                        :onUncheck="onTableExcludedCheck"
                        :onUncheckAll="onTableExcludedCheck"
                        ref="tableTechnicalsSpecificationsExcluded"
                        :results="tableTechnicalSpecificationExcludedResult"
                      ></bootstrapTable>
                    </div>
                  </div>
                </div>
                <div class="tab-pane" id="tabItemBody" role="tabpanel">
                  <div class="row">
                    <div class="col-sm-5">
                      <bootstrapTable
                        addInput="false"
                        :configurations="tableItemIncludedConfiguration"
                        :datas="tableItemIncludedData"
                        id="tableItemsIncluded"
                        :onCheck="onTableItemIncludedCheck"
                        :onCheckAll="onTableItemIncludedCheck"
                        :onUncheck="onTableItemIncludedCheck"
                        :onUncheckAll="onTableItemIncludedCheck"
                        ref="tableItemsIncluded"
                        :results="tableItemIncludedResult"
                      ></bootstrapTable>
                    </div>
                    <div class="col-sm-2 vertical-center">
                      <div class="container-fluid">
                        <div class="row">
                          <button
                            type="button"
                            class="btn btn-block btn-primary"
                            @click="addItem"
                            :disabled="disableAddItemButton"
                          >
                            <i class="fa fa-arrow-left"></i>
                            <span>{{ add }}</span>
                          </button>
                        </div>
                        <div class="row">&nbsp;</div>
                        <div class="row">
                          <button
                            type="button"
                            class="btn btn-block btn-secondary"
                            @click="removeItem"
                            :disabled="disableRemoveItemButton"
                          >
                            <i class="fa fa-arrow-right"></i>
                            <span>{{ remove }}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-5">
                      <bootstrapTable
                        addInput="false"
                        :configurations="tableItemExcludedConfiguration"
                        :datas="tableItemExcludedData"
                        id="tableItemsExcluded"
                        :onCheck="onTableItemExcludedCheck"
                        :onCheckAll="onTableItemExcludedCheck"
                        :onUncheck="onTableItemExcludedCheck"
                        :onUncheckAll="onTableItemExcludedCheck"
                        ref="tableItemsExcluded"
                        :results="tableItemExcludedResult"
                      ></bootstrapTable>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="tab-pane nopadding"
            id="tabGroupsTechinicalsSpecificationsAdminDetail"
            role="tabpanel"
          >
            <div class="card-header">
              <div class="row">
                <div class="col-sm-12">
                  <strong>{{ newGroupTechnicalSpecification }}</strong>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
               <div v-if="rowIdSelected > 0">
                      <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Modifica</h1>
                      </div>
                      <div v-else>
                      <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Aggiungi</h1>
                      </div>
                <pageDetail
                  functions="groupsTechinicalsSpecificationsAdmin"
                  :configurations="detailConfigurations"
                  :jsonValue="detailValues"
                ></pageDetail>
              </div>
              <div class="row">
                <div class="col-lg-12 text-right">
                  <button
                    id="btnCancelNew"
                    type="button"
                    class="btn btn-danger"
                    @click="cancelNewGroupTechinicalsSpecifications"
                  >
                    <i class="fa fa-times"></i>
                    <span>{{ cancel }}</span>
                  </button>
                  <button
                    id="btnAddNew"
                    type="button"
                    class="btn btn-success"
                    @click="saveNewGroupTechinicalsSpecifications"
                  >
                    <i class="fa fa-floppy-o"></i>
                    <span>{{ save }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BootstrapTable from "@/components/BootstrapTable.vue";
import PageDetail from "@/components/PageDetail.vue";

export default {
  name: "groupsTechinicalsSpecificationsAdmin",
  components: {
    BootstrapTable,
    PageDetail
  },
  data() {
    return {
      add: dictionaryHelpers.getDictionary("Add"),
      admin: dictionaryHelpers.getDictionary("Admin"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      code: dictionaryHelpers.getDictionary("Code"),
      confirmDeleteRowSelected: dictionaryHelpers.getDictionary("ConfirmDeleteRowSelected"),
      confirmSaveRowSelected: dictionaryHelpers.getDictionary("ConfirmSaveRowSelected"),
      confirmDuplicateRowSelected: dictionaryHelpers.getDictionary("ConfirmDuplicateRowSelected"),
      configurations: [],
      del: dictionaryHelpers.getDictionary("Delete"),
      deleteCompleted: dictionaryHelpers.getDictionary("DeleteCompleted"),
      detailConfigurations: [],
      detailValues: {},
      description: dictionaryHelpers.getDictionary("Description"),
      disableAddItemButton: true,
      disableAddTechnicalSpecificationButton: true,
      disableButton: true,
      disableRemoveItemButton: true,
      disableRemoveTechnicalSpecificationButton: true,
      disableTab: true,
      duplicate: dictionaryHelpers.getDictionary("Duplicate"),
      excluded: dictionaryHelpers.getDictionary("Excluded"),
      frmGroupsTechinicalsSpecificationsAdmin: 'frmgroupsTechinicalsSpecificationsAdmin',
      group: dictionaryHelpers.getDictionary("Group"),
      groups: dictionaryHelpers.getDictionary("Groups"),
      hasDuplicate: false,
      included: dictionaryHelpers.getDictionary("Included"),
      insertCompleted: dictionaryHelpers.getDictionary("InsertCompleted"),
      idTabDetail: 'tabGroupsTechinicalsSpecificationsAdminDetail',
      idTabTable: 'tabGroupsTechinicalsSpecificationsAdminTable',
      items: dictionaryHelpers.getDictionary("Items"),
      moreRowSelected: dictionaryHelpers.getDictionary('MoreRowSelected'),
      newGroupTechnicalSpecification: dictionaryHelpers.getDictionary("NewGroupTechnicalSpecification"),
      noRowSelected: dictionaryHelpers.getDictionary('NoRowSelected'),
      save: dictionaryHelpers.getDictionary("Save"),
      spanRowSelected: '',
      tabGroup: '#tabGroup',
      tableConfigurations: [],
      tableData: [],
      tableItemIncludedConfiguration: [],
      tableItemIncludedData: [],
      tableItemIncludedResult: [],
      tableItemExcludedConfiguration: [],
      tableItemExcludedData: [],
      tableItemExcludedResult: [],
      tableTechnicalSpecificationIncludedConfiguration: [],
      tableTechnicalSpecificationIncludedData: [],
      tableTechnicalSpecificationIncludedResult: [],
      tableTechnicalSpecificationExcludedConfiguration: [],
      tableTechnicalSpecificationExcludedData: [],
      tableTechnicalSpecificationExcludedResult: [],
      tableResult: [],
      technicalSpecification: dictionaryHelpers.getDictionary("TechnicalSpecification"),
      groupTechnicalSpecification: dictionaryHelpers.getDictionary("GroupTechnicalSpecification"),
      groupTechnicalSpecificationAlreadyExists: dictionaryHelpers.getDictionary("GroupTechnicalSpecificationAlreadyExists"),
      remove: dictionaryHelpers.getDictionary("Remove"),
      rowsSelected: 0,
      updateCompleted: dictionaryHelpers.getDictionary("UpdateCompleted"),
      url: window.location.pathname
    };
  },
  computed: {

  },
  mounted() {
    var groupsTechinicalsSpecificationsAdmin = this;

    languageServices.getConfiguration(function (result) {
      groupsTechinicalsSpecificationsAdmin.configurations = result.data;
      groupsTechinicalsSpecificationsAdmin.tableConfigurations = groupsTechinicalsSpecificationsAdmin.configurations.tablesConfigurations;
      groupsTechinicalsSpecificationsAdmin.detailConfigurations = groupsTechinicalsSpecificationsAdmin.configurations.tabsConfigurations[0].pageConfigurations;
      groupsTechinicalsSpecificationsAdmin.loadTableData();
    });

    groupsTechinicalsSpecificationsAdmin.tableItemIncludedConfiguration = [{
      'inputType': 'TableCheckbox',
      'visibleOnTable': true
    },
    {
      'field': 'internalCodeItem',
      'inputType': 'Input',
      'visibleOnTable': true,
      'filterType': 'Input',
      'title': groupsTechinicalsSpecificationsAdmin.code
    },
    {
      'field': 'descriptionItem',
      'inputType': 'Input',
      'visibleOnTable': true,
      'filterType': 'Input',
      'title': groupsTechinicalsSpecificationsAdmin.description
    }];

    groupsTechinicalsSpecificationsAdmin.tableItemExcludedConfiguration = [{
      'inputType': 'TableCheckbox',
      'visibleOnTable': true
    },
    {
      'field': 'internalCodeItem',
      'inputType': 'Input',
      'visibleOnTable': true,
      'filterType': 'Input',
      'title': groupsTechinicalsSpecificationsAdmin.code
    },
    {
      'field': 'descriptionItem',
      'inputType': 'Input',
      'visibleOnTable': true,
      'filterType': 'Input',
      'title': groupsTechinicalsSpecificationsAdmin.description
    }];

    groupsTechinicalsSpecificationsAdmin.tableTechnicalSpecificationIncludedConfiguration = [{
      'inputType': 'TableCheckbox',
      'visibleOnTable': true
    },
    {
      'field': 'description',
      'inputType': 'Input',
      'visibleOnTable': true,
      'filterType': 'Input',
      'title': groupsTechinicalsSpecificationsAdmin.included
    }];

    groupsTechinicalsSpecificationsAdmin.tableTechnicalSpecificationExcludedConfiguration = [{
      'inputType': 'TableCheckbox',
      'visibleOnTable': true
    },
    {
      'field': 'description',
      'inputType': 'Input',
      'visibleOnTable': true,
      'filterType': 'Input',
      'title': groupsTechinicalsSpecificationsAdmin.excluded
    }];
  },
  methods: {
    /***   GROUP TECHNICAL SPECIFICATION   ***/

    loadTableData() {
      var groupsTechinicalsSpecificationsAdmin = this;
      groupTechnicalSpecificationServices.getDtoTable(function (result) {
        groupsTechinicalsSpecificationsAdmin.tableData = result.data;
      });
      groupsTechinicalsSpecificationsAdmin.disableButton = true;
      groupsTechinicalsSpecificationsAdmin.disableTab = true;
      groupsTechinicalsSpecificationsAdmin.spanRowSelected = '';
      spinnerHelpers.hide();
    },
    groupTechnicalSpecificationItemFormatter(value,row,index,field) {
      return row.internalCodeItem + ' - ' + row.descriptionItem;
    },
    addGroupTechinicalsSpecifications() {
      spinnerHelpers.show();
      this.hasDuplicate = false;
      this.detailValues = {};
      $('#' + this.idTabTable).removeClass('active');
      $('#' + this.idTabDetail).addClass('active');
      spinnerHelpers.hide();
    },
    confirmSaveGroupTechinicalsSpecifications() {
      var groupsTechinicalsSpecificationsAdmin = this;
      if (groupsTechinicalsSpecificationsAdmin.$refs.tableGroupsTechinicalsSpecificationsAdmin.haveRowSelected(true)) {
        if (confirm(groupsTechinicalsSpecificationsAdmin.confirmSaveRowSelected)) {
          spinnerHelpers.show();
          groupsTechinicalsSpecificationsAdmin.saveGroupTechinicalsSpecifications();
        }
      }
    },
    saveGroupTechinicalsSpecifications() {
      var groupsTechinicalsSpecificationsAdmin = this;
      groupsTechinicalsSpecificationsAdmin.tableResult = [];

      $.each(groupsTechinicalsSpecificationsAdmin.$refs.tableGroupsTechinicalsSpecificationsAdmin.getRowSelected(),function (i,row) {
        var rowToSave = {};
        rowToSave.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();
        rowToSave.groupTechnicalSpecificationLanguage = [];

        $.each(row,function (field,value) {
          if (field == 'id') {
            rowToSave.id = value;
          }
          else {
            if (field != 0) {
              var groupTechnicalSpecificationLanguage = {};
              groupTechnicalSpecificationLanguage.idLanguage = field;
              groupTechnicalSpecificationLanguage.description = value;
              rowToSave.groupTechnicalSpecificationLanguage.push(groupTechnicalSpecificationLanguage);
            }
          }
        });

        groupsTechinicalsSpecificationsAdmin.rowsSelected = groupsTechinicalsSpecificationsAdmin.rowsSelected + 1;
        groupTechnicalSpecificationServices.update(rowToSave,
          function () {
            groupsTechinicalsSpecificationsAdmin.checkAllIsSaved();
            groupsTechinicalsSpecificationsAdmin.tableResult.push({ id: rowToSave.id,success: true });
            notificationHelpers.success(groupsTechinicalsSpecificationsAdmin.updateCompleted);
          },
          function (response) {
            groupsTechinicalsSpecificationsAdmin.checkAllIsSaved();
            groupsTechinicalsSpecificationsAdmin.tableResult.push({ id: rowToSave.id,success: false,message: response });
            notificationHelpers.error(response);
          });
      });
    },
    confirmDeleteGroupTechinicalsSpecifications() {
      var groupsTechinicalsSpecificationsAdmin = this;
      if (groupsTechinicalsSpecificationsAdmin.$refs.tableGroupsTechinicalsSpecificationsAdmin.haveRowSelected(true)) {
        if (confirm(groupsTechinicalsSpecificationsAdmin.confirmDeleteRowSelected)) {
          spinnerHelpers.show();
          groupsTechinicalsSpecificationsAdmin.deleteGroupTechinicalsSpecifications();
        }
      }
    },
    deleteGroupTechinicalsSpecifications() {
      var groupsTechinicalsSpecificationsAdmin = this;
      groupsTechinicalsSpecificationsAdmin.tableResult = [];

      $.each(groupsTechinicalsSpecificationsAdmin.$refs.tableGroupsTechinicalsSpecificationsAdmin.getRowSelected(),function (i,row) {
        groupsTechinicalsSpecificationsAdmin.rowsSelected = groupsTechinicalsSpecificationsAdmin.rowsSelected + 1;
        groupTechnicalSpecificationServices.del(row.id,
          function (id) {
            groupsTechinicalsSpecificationsAdmin.checkAllIsSaved();
            groupsTechinicalsSpecificationsAdmin.tableResult.push({ id: id,success: true });
            notificationHelpers.success(groupsTechinicalsSpecificationsAdmin.deleteCompleted);
          },
          function (response,id) {
            groupsTechinicalsSpecificationsAdmin.checkAllIsSaved();
            groupsTechinicalsSpecificationsAdmin.tableResult.push({ id: id,success: false,message: response });
            notificationHelpers.error(response);
          });
      });
    },
    confirmDuplicateGroupTechinicalsSpecifications() {
      if (this.$refs.tableGroupsTechinicalsSpecificationsAdmin.haveRowSelected(true)) {
        if (confirm(this.confirmDuplicateRowSelected)) {
          spinnerHelpers.show();
          this.duplicateGroupTechinicalsSpecifications();
        }
      }
    },
    duplicateGroupTechinicalsSpecifications() {
      spinnerHelpers.show();
      this.hasDuplicate = true;
      this.detailValues = {};
      $('#' + this.idTabTable).removeClass('active');
      $('#' + this.idTabDetail).addClass('active');
      spinnerHelpers.hide();
    },
    checkAllIsSaved() {
      var groupsTechinicalsSpecificationsAdmin = this;
      groupsTechinicalsSpecificationsAdmin.rowsSelected = groupsTechinicalsSpecificationsAdmin.rowsSelected - 1;
      if (groupsTechinicalsSpecificationsAdmin.rowsSelected == 0) {
        groupsTechinicalsSpecificationsAdmin.loadTableData();
      }
    },
    cancelNewGroupTechinicalsSpecifications() {
      var groupsTechinicalsSpecificationsAdmin = this;
      spinnerHelpers.show();
      $('#' + groupsTechinicalsSpecificationsAdmin.idTabTable).addClass('active');
      $('#' + groupsTechinicalsSpecificationsAdmin.idTabDetail).removeClass('active');
      spinnerHelpers.hide();
    },
    saveNewGroupTechinicalsSpecifications() {
      spinnerHelpers.show();
      if ($('.error').length) {
        notificationHelpers.error(dictionaryHelpers.getDictionary('RequiredFieldsNotCompleted'));
        validationHelpers.moveToInvalid();
        spinnerHelpers.hide();
      }
      else {
        var groupsTechinicalsSpecificationsAdmin = this;
        if (validationHelpers.isValid('#' + this.frmGroupsTechinicalsSpecificationsAdmin)) {
          this.tableResult = [];
          groupTechnicalSpecificationServices.insert(this.convertDetailDataToSave(),function (result) {
            groupsTechinicalsSpecificationsAdmin.loadTableData();
            $('#' + groupsTechinicalsSpecificationsAdmin.idTabTable).addClass('active');
            $('#' + groupsTechinicalsSpecificationsAdmin.idTabDetail).removeClass('active');
            groupsTechinicalsSpecificationsAdmin.tableResult.push({ id: result.data,success: true,message: groupsTechinicalsSpecificationsAdmin.insertCompleted });
            notificationHelpers.success(groupsTechinicalsSpecificationsAdmin.insertCompleted);
          });
        }
      }
    },
    convertDetailDataToSave() {
      var dataToSave = {};

      dataToSave.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();
      if (this.hasDuplicate) {
        dataToSave.duplicate = this.$refs.tableGroupsTechinicalsSpecificationsAdmin.getRowSelected()[0].id;
      }
      dataToSave.groupTechnicalSpecificationLanguage = [];

      $.each(this.detailValues,function (field,value) {
        var groupTechnicalSpecificationLanguage = {};
        groupTechnicalSpecificationLanguage.idLanguage = field;
        groupTechnicalSpecificationLanguage.description = value;
        dataToSave.groupTechnicalSpecificationLanguage.push(groupTechnicalSpecificationLanguage);
      });

      return dataToSave;
    },
    onChangeDetail(field,value) {
      var groupsTechinicalsSpecificationsAdmin = this;
      var _field = dataHelpers.unbind(field);
      if (functionHelpers.isValued(value)) {
        groupTechnicalSpecificationServices.checkExists(value,field,null,function (result) {
          if (result.data) {
            if (!$('#' + field).hasClass('error')) {
              $('#' + field).addClass('error');
            }
            notificationHelpers.error(groupsTechinicalsSpecificationsAdmin.groupTechnicalSpecificationAlreadyExists);
          }
          else {
            if ($('#' + field).hasClass('error')) {
              $('#' + field).removeClass('error');
            }
          }
        });
      }
      else {
        if ($('#' + field).hasClass('error')) {
          $('#' + field).removeClass('error');
        }
      }
    },
    onTableCheck() {
      var groupsTechinicalsSpecificationsAdmin = this;
      var countRowSelected = groupsTechinicalsSpecificationsAdmin.$refs.tableGroupsTechinicalsSpecificationsAdmin.countRowSelected();
      if (countRowSelected == 0) {
        groupsTechinicalsSpecificationsAdmin.disableButton = true;
        groupsTechinicalsSpecificationsAdmin.disableTab = true;
      } else {
        if (countRowSelected == 1) {
          groupsTechinicalsSpecificationsAdmin.disableTab = false;
        }
        else {
          groupsTechinicalsSpecificationsAdmin.disableTab = true;
        }
        groupsTechinicalsSpecificationsAdmin.disableButton = false;
      }
    },
    onGroupTab() {
      this.spanRowSelected = '';
    },

    /***   END GROUP TECHNICAL SPECIFICATION   ***/

    /***   TECHNICAL SPECIFICATION   ***/

    onTechnicalSpecificationTab() {
      var groupsTechinicalsSpecificationsAdmin = this;
      var countRowSelected = groupsTechinicalsSpecificationsAdmin.$refs.tableGroupsTechinicalsSpecificationsAdmin.countRowSelected();
      if (countRowSelected == 0) {
        notificationHelpers.error(groupsTechinicalsSpecificationsAdmin.noRowSelected);
      }
      else {
        if (countRowSelected != 1) {
          notificationHelpers.error(groupsTechinicalsSpecificationsAdmin.moreRowSelected);
        }
        else {
          spinnerHelpers.show();
          groupsTechinicalsSpecificationsAdmin.spanRowSelected = groupsTechinicalsSpecificationsAdmin.$refs.tableGroupsTechinicalsSpecificationsAdmin.getRowSelected()[0][storageData.sIdLanguage()];
          groupsTechinicalsSpecificationsAdmin.disableAddTechnicalSpecificationButton = true;
          groupsTechinicalsSpecificationsAdmin.disableRemoveTechnicalSpecificationButton = true;
          groupTechnicalSpecificationServices.getTechnicalSpecification(groupsTechinicalsSpecificationsAdmin.$refs.tableGroupsTechinicalsSpecificationsAdmin.getRowSelected()[0].id,
            function (result) {
              if (functionHelpers.isValued(result.data)) {
                groupsTechinicalsSpecificationsAdmin.tableTechnicalSpecificationIncludedData = result.data.included;
                groupsTechinicalsSpecificationsAdmin.tableTechnicalSpecificationExcludedData = result.data.excluded;
              }
              spinnerHelpers.hide();
            });
        }
      }
    },
    onTableIncludedCheck() {
      var groupsTechinicalsSpecificationsAdmin = this;
      if (groupsTechinicalsSpecificationsAdmin.$refs.tableTechnicalsSpecificationsIncluded.haveRowSelected()) {
        groupsTechinicalsSpecificationsAdmin.disableRemoveTechnicalSpecificationButton = false;
      } else {
        groupsTechinicalsSpecificationsAdmin.disableRemoveTechnicalSpecificationButton = true;
      }
    },
    onTableExcludedCheck() {
      var groupsTechinicalsSpecificationsAdmin = this;
      if (groupsTechinicalsSpecificationsAdmin.$refs.tableTechnicalsSpecificationsExcluded.haveRowSelected()) {
        groupsTechinicalsSpecificationsAdmin.disableAddTechnicalSpecificationButton = false;
      } else {
        groupsTechinicalsSpecificationsAdmin.disableAddTechnicalSpecificationButton = true;
      }
    },
    addTechnicalSpecification() {
      var groupsTechinicalsSpecificationsAdmin = this;
      groupsTechinicalsSpecificationsAdmin.rowsSelected = 0;
      if (groupsTechinicalsSpecificationsAdmin.$refs.tableTechnicalsSpecificationsExcluded.haveRowSelected(true)) {
        spinnerHelpers.show();
        $.each(groupsTechinicalsSpecificationsAdmin.$refs.tableTechnicalsSpecificationsExcluded.getRowSelected(),function (i,row) {
          groupsTechinicalsSpecificationsAdmin.rowsSelected = groupsTechinicalsSpecificationsAdmin.rowsSelected + 1;
          groupTechnicalSpecificationServices.addTechnicalSpecification(groupsTechinicalsSpecificationsAdmin.$refs.tableGroupsTechinicalsSpecificationsAdmin.getRowSelected()[0].id,
            row.id,function (result) {
              groupsTechinicalsSpecificationsAdmin.checkAllTechnicalSpecificationIsSaved();
              notificationHelpers.success(groupsTechinicalsSpecificationsAdmin.updateCompleted);
            });
        });
      }
    },
    removeTechnicalSpecification() {
      var groupsTechinicalsSpecificationsAdmin = this;
      groupsTechinicalsSpecificationsAdmin.rowsSelected = 0;
      if (groupsTechinicalsSpecificationsAdmin.$refs.tableTechnicalsSpecificationsIncluded.haveRowSelected(true)) {
        spinnerHelpers.show();
        $.each(groupsTechinicalsSpecificationsAdmin.$refs.tableTechnicalsSpecificationsIncluded.getRowSelected(),function (i,row) {
          groupsTechinicalsSpecificationsAdmin.rowsSelected = groupsTechinicalsSpecificationsAdmin.rowsSelected + 1;
          groupTechnicalSpecificationServices.deleteGroupTechnicalSpecificationTechnicalSpecification(row.id,function (result) {
            groupsTechinicalsSpecificationsAdmin.checkAllTechnicalSpecificationIsSaved();
            notificationHelpers.success(groupsTechinicalsSpecificationsAdmin.updateCompleted);
          });
        });
      }
    },
    checkAllTechnicalSpecificationIsSaved() {
      var groupsTechinicalsSpecificationsAdmin = this;
      groupsTechinicalsSpecificationsAdmin.rowsSelected = groupsTechinicalsSpecificationsAdmin.rowsSelected - 1;
      if (groupsTechinicalsSpecificationsAdmin.rowsSelected == 0) {
        groupsTechinicalsSpecificationsAdmin.onTechnicalSpecificationTab();
      }
    },

    /***   END TECHNICAL SPECIFICATION   ***/

    /***   ITEM   ***/

    onItemTab() {
      var groupsTechinicalsSpecificationsAdmin = this;
      var countRowSelected = groupsTechinicalsSpecificationsAdmin.$refs.tableGroupsTechinicalsSpecificationsAdmin.countRowSelected();
      if (countRowSelected == 0) {
        notificationHelpers.error(groupsTechinicalsSpecificationsAdmin.noRowSelected);
      }
      else {
        if (countRowSelected != 1) {
          notificationHelpers.error(groupsTechinicalsSpecificationsAdmin.moreRowSelected);
        }
        else {
          spinnerHelpers.show();
          groupsTechinicalsSpecificationsAdmin.spanRowSelected = groupsTechinicalsSpecificationsAdmin.$refs.tableGroupsTechinicalsSpecificationsAdmin.getRowSelected()[0][storageData.sIdLanguage()];
          groupsTechinicalsSpecificationsAdmin.disableAddItemButton = true;
          groupsTechinicalsSpecificationsAdmin.disableRemoveItemButton = true;
          groupTechnicalSpecificationServices.getItems(groupsTechinicalsSpecificationsAdmin.$refs.tableGroupsTechinicalsSpecificationsAdmin.getRowSelected()[0].id,
            function (result) {
              if (functionHelpers.isValued(result.data)) {
                groupsTechinicalsSpecificationsAdmin.tableItemIncludedData = result.data.included;
                groupsTechinicalsSpecificationsAdmin.tableItemExcludedData = result.data.excluded;
              }
              spinnerHelpers.hide();
            });
        }
      }
    },
    onTableItemIncludedCheck() {
      var groupsTechinicalsSpecificationsAdmin = this;
      if (groupsTechinicalsSpecificationsAdmin.$refs.tableItemsIncluded.haveRowSelected()) {
        groupsTechinicalsSpecificationsAdmin.disableRemoveItemButton = false;
      } else {
        groupsTechinicalsSpecificationsAdmin.disableRemoveItemButton = true;
      }
    },
    onTableItemExcludedCheck() {
      var groupsTechinicalsSpecificationsAdmin = this;
      if (groupsTechinicalsSpecificationsAdmin.$refs.tableItemsExcluded.haveRowSelected()) {
        groupsTechinicalsSpecificationsAdmin.disableAddItemButton = false;
      } else {
        groupsTechinicalsSpecificationsAdmin.disableAddItemButton = true;
      }
    },
    addItem() {
      var groupsTechinicalsSpecificationsAdmin = this;
      groupsTechinicalsSpecificationsAdmin.rowsSelected = 0;
      if (groupsTechinicalsSpecificationsAdmin.$refs.tableItemsExcluded.haveRowSelected(true)) {
        spinnerHelpers.show();
        $.each(groupsTechinicalsSpecificationsAdmin.$refs.tableItemsExcluded.getRowSelected(),function (i,row) {
          groupsTechinicalsSpecificationsAdmin.rowsSelected = groupsTechinicalsSpecificationsAdmin.rowsSelected + 1;
          groupTechnicalSpecificationServices.addItem(groupsTechinicalsSpecificationsAdmin.$refs.tableGroupsTechinicalsSpecificationsAdmin.getRowSelected()[0].id,
            row.id,function (result) {
              groupsTechinicalsSpecificationsAdmin.checkAllItemIsSaved();
              notificationHelpers.success(groupsTechinicalsSpecificationsAdmin.updateCompleted);
            });
        });
      }
    },
    removeItem() {
      var groupsTechinicalsSpecificationsAdmin = this;
      groupsTechinicalsSpecificationsAdmin.rowsSelected = 0;
      if (groupsTechinicalsSpecificationsAdmin.$refs.tableItemsIncluded.haveRowSelected(true)) {
        spinnerHelpers.show();
        $.each(groupsTechinicalsSpecificationsAdmin.$refs.tableItemsIncluded.getRowSelected(),function (i,row) {
          groupsTechinicalsSpecificationsAdmin.rowsSelected = groupsTechinicalsSpecificationsAdmin.rowsSelected + 1;
          groupTechnicalSpecificationServices.deleteItemGroupTechnicalSpecification(row.id,function (result) {
            groupsTechinicalsSpecificationsAdmin.checkAllItemIsSaved();
            notificationHelpers.success(groupsTechinicalsSpecificationsAdmin.updateCompleted);
          });
        });
      }
    },
    checkAllItemIsSaved() {
      var groupsTechinicalsSpecificationsAdmin = this;
      groupsTechinicalsSpecificationsAdmin.rowsSelected = groupsTechinicalsSpecificationsAdmin.rowsSelected - 1;
      if (groupsTechinicalsSpecificationsAdmin.rowsSelected == 0) {
        groupsTechinicalsSpecificationsAdmin.onItemTab();
      }
    }

    /***   END ITEM   ***/
  }
}
</script>
